/**
 * 토스트 컨테이너 컴포넌트
 *
 * 화면 우측 하단에 토스트 알림들을 렌더링합니다.
 * Zustand toastStore에서 관리되는 모든 토스트를 표시합니다.
 *
 * 일반적으로 앱 최상위 레이아웃에 한 번만 추가하면,
 * useToast hook을 통해 어디서나 토스트를 표시할 수 있습니다.
 *
 * @component
 * @example
 * // 앱 레이아웃에 추가 (보통 layout.tsx)
 * <AppToastContainer />
 *
 * // 어디서나 사용
 * const { toast } = useToast();
 * toast({ type: 'success', message: '완료!' });
 *
 * @returns {JSX.Element | null} 토스트 목록 컨테이너 (토스트가 없으면 null)
 */

'use client';

import { useToastStore, selectToasts } from '@/lib/stores/toastStore';
import { AppToast } from './AppToast';

export function AppToastContainer() {
  const toasts = useToastStore(selectToasts);
  const removeToast = useToastStore((state) => state.removeToast);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-0 right-0 z-50 p-4 space-y-3 pointer-events-none">
      {toasts.map((toast) => (
        <AppToast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
      ))}
    </div>
  );
}
